import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ShareService } from 'src/app/core/services/share.service';

let INFO_JSON2 = [
  {
    id: "1",
    label: "AM"
  },
  {
    id: "2",
    label: "PM"
  },
  {
    id: "3",
    label: "Todo el día"
  },
];

let INFO_JSON3 = [
  {
    id: "1",
    label: "Trabajo administrativo oficina",
  },
  {
    id: "2",
    label: "Trabajo administrativo home office",
  },
  {
    id: "3",
    label: "Búsqueda de oportunidades",
  },
  {
    id: "4",
    label: "Contacto con clientes",
  },
];

@Component({
  selector: 'app-activity-modal',
  templateUrl: './activity-modal.component.html',
  styleUrls: ['./activity-modal.component.css']
})
export class ActivityModalComponent implements OnInit {

  title: string;
  dataJson: string;
  minDate = moment();
  canDelete: boolean = false;
  isEditable: boolean = true;

  
  newActivity = new FormGroup({
    date: new FormControl(null, { validators: Validators.required }),
    time: new FormControl(null, { validators: Validators.required }),
    type: new FormControl(null, { validators: Validators.required }),
    summary: new FormControl(null, { validators: Validators.required }),
  });

  timeDayList = [];
  typeActivityList = [];

  constructor(public dialogRef: MatDialogRef<ActivityModalComponent>,
    private shareService: ShareService,
    @Inject(MAT_DIALOG_DATA) public data: ActivityModalComponent) {
    this.title = data.title;
    this.dataJson = data.dataJson;

    if (data.isEditable != undefined && data.isEditable != null) {
      this.isEditable = data.isEditable;
      this.newActivity = new FormGroup({
        date: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        time: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        type: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        summary: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
      });
    }

    if (data.canDelete !=undefined && data.canDelete != null && data.canDelete != false){
      this.canDelete = true;
    }
    if (this.dataJson != null){
      //console.log(this.dataJson['date'])
      this.newActivity.controls['date'].setValue(this.dataJson['date']);
      this.newActivity.controls['time'].setValue(this.dataJson['time']['id']);
      this.newActivity.controls['type'].setValue(this.dataJson['type']['id']);
      this.newActivity.controls['summary'].setValue(this.dataJson['summary']);
    }
  }

  ngOnInit() {
    this.shareService.getActivityTime().subscribe(
      response => {
        this.timeDayList = response;
      },
      error => {
      }
    )

    this.shareService.getActivityType().subscribe(
      response => {
        this.typeActivityList = response;
      },
      error => {
      }
    )
  }

  onConfirm(): void {
    if (this.dataJson != null) {
      // es para Editar y Actualizar DATA
      if (this.newActivity.valid){       
        if (this.newActivity.controls['time'].value == 1) {
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T05:00:00";
          this.newActivity.controls['date'].setValue(date);
        } else if (this.newActivity.controls['time'].value == 2) {
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T18:00:00";
          this.newActivity.controls['date'].setValue(date);
        } else if (this.newActivity.controls['time'].value == 3) {
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T00:00:00";
          this.newActivity.controls['date'].setValue(date);
        }
        
        let response = {data: this.newActivity.value, status: true, hasNew: false, hasDelete: false}
        this.dialogRef.close(response);
      }
    } else {
      // Es para Crear una visita
      if (this.newActivity.valid){
        if (this.newActivity.controls['time'].value == 1) {
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T05:00:00";
          this.newActivity.controls['date'].setValue(date);
        } else if (this.newActivity.controls['time'].value == 2) {          
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T18:00:00";
          this.newActivity.controls['date'].setValue(date)
        } else if (this.newActivity.controls['time'].value == 3) {
          let date = moment(this.newActivity.controls['date'].value).utc().format('YYYY-MM-DD')+"T00:00:00";
          this.newActivity.controls['date'].setValue(date);
        }
        let response = {data: this.newActivity.value, status: true, hasNew: true, hasDelete: false}
        this.dialogRef.close(response);
      }
    }
  }

  onDismiss(): void {
    let response = {data: null, status: false}
    this.dialogRef.close(response);
  }

  onDelete() : void {
    let response = {data: this.dataJson, status: true, hasNew: false, hasDelete: true}
    this.dialogRef.close(response);
  }
  
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
 export class ActivityModalModel {

  constructor(public title: string, public dataJson: string, public canDelete: boolean = false,  public isEditable: boolean = true) {
  }
}

